import { Dispatch, Action } from "redux";
import { HttpRequest, IErrorData, IRequest } from "../../../utilities/HttpRequest";
import { ProgressSpinnerSlice } from "../../ProgressSpinner/Index";
import { handleException } from "../../../ErrorMessages/helper";
import { IGetExtractDetails, IExtract } from "./redux/Types";
import { ExtractListSlice } from "./index";

export const getPayLoad = (extractParam: IGetExtractDetails): IRequest => {
  return {
    relativeUrl: "/extract/list?financialYear=" + extractParam.selectedYear + "&pageSize="
      + extractParam.resultPerPage + "&pageNo=" + extractParam.pageNumber
  };
};

/**
 * To get the assessment list
 * @param dispatch Function to dispatch
 * @param extractParam assessment meta data
 */
export const GetExtractList = (
  dispatch: Dispatch<Action>,
  extractParam: IGetExtractDetails
): void => {
  dispatch(ProgressSpinnerSlice.actions.showProgressBar("LoadingMessage.GetExtractList"));
  HttpRequest.get(getPayLoad(extractParam)).then((response: IExtract) => {
    dispatch(ExtractListSlice.actions.setExtractData(response));
  }).catch((err: IErrorData) => {
    handleException(err, dispatch, "GetExtractListErrMsg");
  }).finally(() => {
    dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
  });
};
